import { AuditLogEntityName } from "@/api-schema-enums";
import { cn } from "@/common/helpers/utils";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDownIcon, HistoryIcon } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AuditLogTimeline } from "./audit-log-timeline";

interface AuditLogCardProps {
  entityName: AuditLogEntityName;
  uuid: string;
}

export const AuditLogCard = ({ entityName, uuid }: AuditLogCardProps) => {
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);

  return (
    <Card>
      <Collapsible open={open} onOpenChange={setOpen}>
        <CardHeader>
          <CollapsibleTrigger className="flex w-full cursor-pointer items-center justify-between text-left">
            <CardTitle className="flex items-center gap-2 text-lg">
              <HistoryIcon className="h-5 w-5" />
              {t("common:AuditLog")}
            </CardTitle>
            <ChevronDownIcon className={cn("h-4 w-4 transition-transform", open && "rotate-180")} />
          </CollapsibleTrigger>
        </CardHeader>
        <CollapsibleContent>
          <CardContent className="pt-4">
            <AuditLogTimeline entityName={entityName} uuid={uuid} enabled={open} />
          </CardContent>
        </CollapsibleContent>
      </Collapsible>
    </Card>
  );
};
